import {ProfileComponent} from './profile/profile.component';
import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ProfileEditComponent} from './profile-edit/profile-edit.component';
import {UsersComponent} from './users/users.component';
import {UserComponent} from './user/user.component';
import {UserEditComponent} from './user-edit/user-edit.component';
import {RolesComponent} from './roles/roles.component';
import {RoleComponent} from './role/role.component';
import {RoleEditComponent} from './role-edit/role-edit.component';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {SettingsComponent} from './settings/settings.component';
import {StorageComponent} from './storage/storage.component';
import {AuditComponent} from './audit/audit.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'profile',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            component: ProfileComponent,
            canActivate: [AuthGuard],
            data: {
              menuGroup: MenuGroupEnum.SettingsGroup,
              package: ModulesEnum.UsersModule,
              permissions: [RolesEnum.AccountProfile_View, RolesEnum.AccountProfile_Edit],
              meta: {
                title: 'Profile',
                override: true,
                description: 'User Profile Page',
                inSideMenu: false,
                iconClass: 'material-icons',
                iconClassCode: 'person',
              }
            }
          },
          {
            path: 'edit',
            component: ProfileEditComponent,
            canActivate: [AuthGuard],
            data: {
              menuGroup: MenuGroupEnum.SettingsGroup,
              package: ModulesEnum.UsersModule,
              permissions: [RolesEnum.AccountProfile_Edit],
              meta: {
                title: 'Edit Profile',
                override: true,
                description: 'Edit User Profile Page',
                inSideMenu: false,
                iconClass: 'material-icons',
                iconClassCode: 'person',
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      package: ModulesEnum.AccountUsersModule,
      permissions: [RolesEnum.AccountUsers_View, RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete],
      meta: {
        title: 'Users',
        override: true,
        description: 'Users Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'person',
      }
    }
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: ':id',
            children: [
              {
                path: '',
                component: UserComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.SettingsGroup,
                  package: ModulesEnum.AccountUsersModule,
                  permissions: [RolesEnum.AccountUsers_View, RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete],
                  meta: {
                    title: 'User Details',
                    override: true,
                    description: 'User Details Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'person',
                  }
                }
              },
              {
                path: 'edit',
                component: UserEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.SettingsGroup,
                  package: ModulesEnum.AccountUsersModule,
                  permissions: [RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete],
                  meta: {
                    title: 'Edit User Details',
                    override: true,
                    description: 'Edit User Details Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'person',
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'roles',
    component: RolesComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      package: ModulesEnum.AccountRolesModule,
      permissions: [RolesEnum.AccountRoles_View, RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete],
      meta: {
        title: 'Roles',
        override: true,
        description: 'Roles Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'admin_panel_settings',
      }
    }
  },
  {
    path: 'role',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: ':id',
            children: [
              {
                path: '',
                component: RoleComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.SettingsGroup,
                  package: ModulesEnum.AccountRolesModule,
                  permissions: [RolesEnum.AccountRoles_View, RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete],
                  meta: {
                    title: 'Role Details',
                    override: true,
                    description: 'Role Details Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'admin_panel_settings',
                  }
                }
              },
              {
                path: 'edit',
                component: RoleEditComponent,
                canActivate: [AuthGuard],
                data: {
                  menuGroup: MenuGroupEnum.SettingsGroup,
                  package: ModulesEnum.AccountRolesModule,
                  permissions: [RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete],
                  meta: {
                    title: 'Edit Role Details',
                    override: true,
                    description: 'Edit Role Details Page',
                    inSideMenu: false,
                    iconClass: 'material-icons',
                    iconClassCode: 'admin_panel_settings',
                  }
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      package: ModulesEnum.AccountSettingsModule,
      permissions: [RolesEnum.AccountSettings_View, RolesEnum.AccountSettings_Edit, RolesEnum.AccountSettings_Delete],
      meta: {
        title: 'Settings',
        override: true,
        description: 'Account Settings Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'settings',
      }
    }
  },
  {
    path: 'retention',
    component: StorageComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      package: ModulesEnum.AccountStorageModule,
      permissions: [RolesEnum.AccountStorage_View, RolesEnum.AccountStorage_Edit, RolesEnum.AccountStorage_Delete],
      meta: {
        title: 'Retention',
        override: true,
        description: 'Account Retention Settings Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'storage',
      }
    }
  },
  {
    path: 'custom-fields',
    loadChildren: () => import('./custom-fields/custom-fields.module').then(m => m.CustomFieldsModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'audit',
    component: AuditComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.SettingsGroup,
      package: ModulesEnum.AuditModule,
      permissions: [RolesEnum.Audit_View, RolesEnum.Audit_Edit, RolesEnum.Audit_Delete],
      animation: 'main',
      meta: {
        title: 'Audit',
        override: true,
        description: 'Audit Page',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'policy',
        order: 4
      }
    }
  },
];
